<div [class.modal]="true" [class.fade]="true" [class.in]="true" role="dialog" [ngStyle]="{'display': 'none'}" id="userModal" >
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <button type="button" class="close"  data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-times" aria-hidden="true"></i></button>
                <h4 *ngIf="isNewDialog()" class="modal-title"><i class="fa fa-user-plus" aria-hidden="true"></i>&nbsp;<span>ADD NEW USER</span></h4>
                <h4 *ngIf="isEditDialog() || isProfileDialog()" class="modal-title"><i class="fa fa-user" aria-hidden="true"></i>&nbsp;<span >USER: {{mUserName}}</span></h4>
            </div>

                <div class="modal-body">

                    <ul class="nav nav-tabs">
                        <li class="active"><a data-toggle="tab" href="#main">PROFILE</a></li>
                        <!-- <li><a data-toggle="tab" href="#addtl">ADDITIONAL INFO</a></li> -->
                      </ul>

                      <div class="tab-content" id="user-tab">
                        <div id="main" class="tab-pane fade in active">
                            <div class="row">
                                <div class="col-sm-3">
                                  <img [src]="imageSource()" class="img-responsive profile" />
                                  <input type="file" #userImage (change)="onImageFileChange($event)" style="display:none" accept=".gif,.jpg,.png"/>
                                  <div class="btn-group">
                                    <button class="btn btn-sm btn-default change-button" (click)="changeImageClicked()" [disabled]="onlyPassword"> CHANGE</button>
                                    <button class="btn btn-sm btn-default" (click)="resetImage()" [disabled]="onlyPassword"><i class="fa fa-times" aria-hidden="true"></i></button>
                                  </div>
                                </div>

                                <div class="col-sm-9">
                                  <h6 align="right">*ALL FIELDS REQUIRED</h6>
                                    <form class="form-horizontal">

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="login">LOGIN:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="login" name="login" placeholder="USERNAME" [(ngModel)]="mUser.login" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="firstName">FIRST NAME:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="firstName" name="firstName" placeholder="FIRST NAME" [(ngModel)]="mUser.firstName" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="lastName">LAST NAME:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="lastName" name="lastName" placeholder="LAST NAME" [(ngModel)]="mUser.lastName" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="email">EMAIL:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="email" name="email" placeholder="EMAIL" [(ngModel)]="mUser.email" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="phoneNumber">PHONE:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="phoneNumber" name="phoneNumber" placeholder="PHONE" [(ngModel)]="mUser.phoneNumber" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <div class="form-group">
                                              <label class="control-label col-sm-4" for="cellNumber">MOBILE:</label>
                                              <div class="col-sm-8">
                                                <input type="text" class="form-control" id="cellNumber" name="cellNumber" placeholder="MOBILE" [(ngModel)]="mUser.cellNumber" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                              </div>
                                            </div>

                                            <!-- TWO FACTOR AUTHENTICATION TOGGLE -->
                                            <div class="form-group">
                                                <label class="control-label col-sm-4" for="twoFactorEnabled">MFA Enabled:</label>
                                                <div class="col-sm-8">
                                                <input type="checkbox" class="form-control" id="twoFactorEnabled" name="twoFactorEnabled"
                                                    [(ngModel)]="mUser.twoFactorEnabled" [disabled]="onlyPassword" [readonly]="onlyPassword">
                                                </div>
                                            </div>

                                            <div [class.form-group]="true" [class.has-success]="mIsPasswordValid" [class.has-error]="!mIsPasswordValid">
                                                    <label class="control-label col-sm-4" for="userPassword">PASSWORD:</label>
                                                        <span class="col-sm-8">
                                                        <input type="password" id="userPassword" class="form-control" name="password" aria-describedby="passwordStatus" (keyup)="checkPassword()" [(ngModel)]="mUser.password" />
                                                        <span class="password-glyph"  [class.glyphicon]="true"	[class.form-control-feedback]="true" [class.glyphicon-remove]="!mIsPasswordValid" [class.glyphicon-ok]="mIsPasswordValid" aria-hidden="true"></span>
                                                        </span>
                                                        <br>
                                                        <div *ngIf="mPasswordErrorMessage != null" class="password-text help-block">{{mPasswordErrorMessage}}</div>
                                            </div>
                                        </form>
                                </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-7">
                                <!-- ROLE TYPE -->
                                <h5>ROLE TYPES</h5>
                                <angular2-multiselect *ngIf="!this.onlyPassword" [data]="roleDropDownList" [(ngModel)]="roleSelectedItems" [settings]="roleDropDownSettings"
                                (onSelect)="selectRoleItem($event)" (onDeSelect)="deselectRoleItem($event)" (onSelectAll)="selectAllRoleItems()" (onDeSelectAll)="deselectAllRoleItems()"
                                ></angular2-multiselect>
                                <angular2-multiselect *ngIf="this.onlyPassword" [data]="roleDropDownList" [(ngModel)]="roleSelectedItems" [settings]="roleDropDownSettingsDisabled"
                                (onSelect)="selectRoleItem($event)" (onDeSelect)="deselectRoleItem($event)" (onSelectAll)="selectAllRoleItems()" (onDeSelectAll)="deselectAllRoleItems()"
                                ></angular2-multiselect>

                          <!--<span class="control-group">
                              <ng-container *ngFor="let group of mAvailableGroups">
                                        <div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="group.mSelected" [ngModelOptions]="{standalone: true}" [disabled]="isProfileDialog()" class="styled"><label for="checkbox"></label></div>
                                {{group.mGroup.name}}
                              </ng-container>
                             </span> -->
                              </div>

                             <!-- TAG ID -->
                              <div class="col-sm-5">
                                  <h5>TRACKED AS</h5>
                                <select class="form-control ng-pristne ng-valid" (change)="personSelected($event.target.value)" [disabled]="onlyPassword">
                                  <option value="-1">-- NOT TRACKED --</option>
                                  <ng-container *ngFor="let person of mAvailablePeople">
                                    <option value="{{ person.id }}" [selected]="mPerson && person.id == mPerson.id">{{person.name}}</option>
                                  </ng-container>

                                </select>
                              </div>
                            </div>
                        </div>
                        <div id="addtl" class="tab-pane fade">
                           None. <a [routerLink]="'/customFields'" data-dismiss="modal"> Click here</a> to add custom fields.
                        </div>
                    </div>






                </div>
             <!-- CLEAR DATA / CREATE USER BUTTONS -->
             <div class="modal-footer">
                <button type="button" class="btn btn-default"  data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
                <button *ngIf="isNewDialog()" type="submit" class="btn btn-primary" (click)="addUser()" ><i class="fa fa-user-plus" aria-hidden="true"></i> ADD USER</button>
                <button *ngIf="isEditDialog() || isProfileDialog()" type="submit" class="btn btn-primary" (click)="updateUser()" ><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE USER</button>
            </div>
        </div>
    </div>
</div>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>